import styled from 'styled-components';

export const FlagTextWrapper = styled.div`
  display: flex;
  align-items: center;
`;
